import { appConfig, apiConfig } from './../config'

export default {
    data() {
        return {
            uploadedFiles: []
        }
    },
    methods: {
        formatName(value) {
            if (value) {
                const attachmentUrl = value.split('/')

                return attachmentUrl[attachmentUrl.length - 1]
            }
        },
        clicked() {
            this.$refs.input.click()
        },
        changed(files) {
            this.attachmentError = []

            if (files.length === 0) {
                return
            }

            const types = this.accept ? this.accept.split(',') : []

            for (let i = 0, file, push; i < files.length; i++) {
                file = files[i]
                push = this.accept === null ? true : false

                if (file.size >= appConfig.common.attachmentSize * 1024 * 1024) {
                    push = false
                    this.attachmentError= this.attachmentErrors()
                }

                for (let j = 0, type; j < types.length; j++) {
                    type = types[j].trim()
                    if (type === file.type ||
                    type.endsWith('*') &&
                    file.type.startsWith(type.substring(0, type.length - 1))) {
                        push = true
                        break
                    }
                }

                for (let j = 0, item; j < this.items.length; j++) {
                    item = this.items[j]
                    if (item.name === file.name) {
                        push = false
                        break
                    }
                }

                if (push) {
                    this.items.push({
                        name: file.name,
                        type: file.type,
                        size: file.size,
                        file
                    })
                }
            }
            this.$refs.input.value = ''
        },
        remove(index) {
            this.attachmentError = []
            this.items.splice(index, 1)
        },
        preview(item) {
            this.attachmentError = []
            if (item.file || item.blob) {
                this.selected = item
            } else if (this.fetch) {
                this.fetch(item).then(() => this.selected = item)
            }
        },
        attachmentErrors() {
            const errors = []

            errors.push(`Plik zbyt duży, dopuszczalny rozmiar to ${appConfig.common.attachmentSize}MB.`)

            return errors
        },
        createUploadedUrls(data) {
            const mediaRoot = apiConfig.FACTORYBASE_API_URI

            data.map(item => {
                this.uploadedFiles.push(mediaRoot + item.file)
            })
        },
        openInNewTab(url) {
            window.open(url, '_blank').focus()
        },
    }

}

